import { faTwitter } from '@fortawesome/free-brands-svg-icons';
import objectToGetParams from '../objectToGetParams';
import { ISocialLink } from '@components/Homepage/Header/interfaces';

const twitter = (title: string, url: string): ISocialLink => ({
  icon: faTwitter,
  link: `https://twitter.com/share${objectToGetParams({
    url,
    text: title,
  })}`,
});

export default twitter;
